import { FC } from "react";

/** Thin-outline padlock shown in the "Today's Insight" pill while it's locked. */
export const IconLock: FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 9 10"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M7 4.5V3C7 1.61929 5.88071 0.5 4.5 0.5C3.11929 0.5 2 1.61929 2 3V4.5M2.9 9.5H6.1C6.94008 9.5 7.36012 9.5 7.68099 9.33651C7.96323 9.1927 8.1927 8.96323 8.33651 8.68099C8.5 8.36012 8.5 7.94008 8.5 7.1V6.9C8.5 6.05992 8.5 5.63988 8.33651 5.31901C8.1927 5.03677 7.96323 4.8073 7.68099 4.66349C7.36012 4.5 6.94008 4.5 6.1 4.5H2.9C2.05992 4.5 1.63988 4.5 1.31901 4.66349C1.03677 4.8073 0.807301 5.03677 0.663491 5.31901C0.5 5.63988 0.5 6.05992 0.5 6.9V7.1C0.5 7.94008 0.5 8.36012 0.663491 8.68099C0.807301 8.96323 1.03677 9.1927 1.31901 9.33651C1.63988 9.5 2.05992 9.5 2.9 9.5Z" />
  </svg>
);

export default IconLock;
